<template>
    <div class="news-shortcut-container">
        <div class="left-wrap">
            <ul class="news-tab-list">
                <li class="news-tab" :class="{'active': currentTab === 'information'}" @click="handleTab('information')">
                    {{ aliasMap.news || '新闻资讯' }}
                    <div class="under-line"></div>
                </li>
                <li class="divider-wrap"></li>
                <li class="news-tab" :class="{'active': currentTab === 'notice'}" @click="handleTab('notice')">
                    {{ aliasMap.notice || '通知公告' }}
                    <div class="under-line"></div>
                </li>
                <li class="more-btn pointer"  @click="goList">更多 ></li>
            </ul>
            <NewsWrap
                v-if="currentTab === 'information'"
                :data="data.newsList"/>
            <NoticeWrap
                v-else
                :data="data.noticeList"/>
        </div>
        <div class="right-wrap">
            <div class="common-header-wrap">
                <div class="name">快捷入口</div>
                <div class="under-line"></div>
            </div>
            <ShortcutWrap
                :data="data.quickList"/>
        </div>
    </div>
</template>

<script setup>
import NewsWrap from './news.vue';
import NoticeWrap from './notice.vue';
import ShortcutWrap from './shortcut.vue';
import { ref, computed, onMounted, reactive } from 'vue';
import { pageJump } from '@/global/location-transfer';
import { useStore } from 'vuex';
import dayjs from 'dayjs';

const store = useStore();

let currentTab = ref('notice');

const props = defineProps({
    alias: {
        type: Array,
        default: () => {
            return [];
        }
    }
});

// 全部备案信息
const brand = computed(() => {
    return store.state.brand || {};
});

// 是否是首都师小站点
const isSdsx = computed(() => {
    // 只有首都师小站点需要改模板文字
    return brand.value?.publishBrand?.brand == 'sdsx';
});

const aliasMap = computed(() => {
    let temp = {};
    (props.alias || []).forEach(item => {
        if (item.modelName === 'news' && isSdsx.value) {
            temp[item.modelName] = '云研动态'
        } else {
            temp[item.modelName] = item.aliasName || item.name;
        }
    })
    return temp;
})

// 切换tab
function handleTab (val) {
    currentTab.value = val;
    getFirstScreenContent(val);
}


// 是否显示更多公告新闻
const isShowMore = computed(() => {
    if(currentTab.value === 'information') {
        let list = data.newsList ?? [];
        return list.length > 0;
    }
    let noticeList = data.noticeList ?? [];
    return noticeList.length > 0;
})

// 跳转新闻或者公告列表页
function goList () {
    pageJump({name: currentTab.value === 'information' ? 'information' : 'notice'});
}

const data = reactive({
    bannerList: [], // banner列表
    newsList: [], // 新闻咨询列表
    noticeList: [], // 通知公告列表数据
    quickList: [] // 快捷入口列表数据
});

// 应用类型对应
const instAppTypeMap = {
    topic: '1', // 专题
    lesson: '2', // 同步备课
    banner: '3', // banner
    notice: '4', // 通知公告
    information: '5', // 新闻资讯
    expert_team: '6', // 专家团队
    monitor: '7', // 测评
    cooperateOrg: '8', // 合作机构
    quick: '9', // 快捷入口
    yanxiu_star: '10', // 研修之星
    portal: '11' // 门户
}



// 排序类型对应
const orderTypeMap = {
    banner: 'sort',
    notice: 'recommend',
    information: 'recommend',
    quick: 'sort'
}



// 获取banner/新闻咨询/通知公告/快捷入口数据
const getFirstScreenContent = (type) => {
    let params = getRequesetParams(type);
    G_transmit('getFirstScreenContent', {
        name: 'getFirstScreenContent',
        queries: params
    }).then(res => {
        let result = res?.data?.rows || [];
        result.forEach(item => {
            item.publishTime = dayjs(item.publishTime).format('YYYY.MM.DD');
        })
        switch (type) {
            case 'banner':
                data.bannerList = result;
                break
            case 'information':
                data.newsList = result;
                break
            case 'notice':
                data.noticeList = result;
                break
            case 'quick':
                data.quickList = result;
                break
        }
    });
}

function getRequesetParams (type) {
    let params = {};
    switch(type) {
        case 'banner': {
            params = {
                instAppTypeId: instAppTypeMap[type],
                pageIndex: 1,
                pageSize: 6,
                orderType: orderTypeMap[type],
                publishPlace: 'PC',
                publishState: 1 // 发布状态
            }
            break;
        }
        case 'information': {
            params = {
                instAppTypeId: instAppTypeMap[type],
                pageIndex: 1,
                pageSize: 7,
                orderType: orderTypeMap[type],
                publishPlace: 'PC',
                publishState: 1 // 发布状态
            }
            break;
        }
        case 'notice': {
            params = {
                instAppTypeId: instAppTypeMap[type],
                pageIndex: 1,
                pageSize: 7,
                orderType: orderTypeMap[type],
                publishPlace: 'PC',
                publishState: 1 // 发布状态
            }
            break;
        }
        case 'quick': {
            params = {
                instAppTypeId: instAppTypeMap[type],
                pageIndex: 1,
                pageSize: 10,
                orderType: orderTypeMap[type],
                publishState: 1 // 发布状态
            }
            break;
        }
    }
    return params;
}

onMounted(() => {
    // 获取新闻咨询数据
    getFirstScreenContent('information');
    // 获取通知公告数据
    getFirstScreenContent('notice');
    // 获取快捷入口数据
    getFirstScreenContent('quick');
})

</script>

<style lang="scss" scoped>
.news-shortcut-container {
    margin-top: 40px;
    height: 284px;
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    .left-wrap {
        width: 820px;
    }
    .right-wrap {
        width: 278px;
    }
    .news-tab-list {
        position: relative;
        display: flex;
        align-items: center;
        border-bottom: 1px solid var(--home-border-color);
        .news-tab {
            position: relative;
            font-size: 15px;
            color: #333333;
            line-height: 29px;
            font-weight: bold;
            padding-bottom: 10px;
            cursor: pointer;
            .under-line {
                position: absolute;
                bottom: -1px;
                width: 100%;
                height: 4px;
                background-color: var(--home-main-color);
                display: none;
            }
            &.active {
                font-size: 22px;
                color: var(--home-main-color);
                display: block;
                .under-line {
                    display: block;
                }
            }
        }
        .divider-wrap {
            width: 1px;
            height: 16px;
            line-height: 29px;
            margin: 0 15px;
            background: var(--home-border-color);
            border-left: 1px solid var(--home-border-color);
            margin-bottom: 10px;
        }
        .more-btn {
            position: absolute;
            right: 0;
            color: var(--home-main-color);
        }
    }
    .common-header-wrap {
        position: relative;
        border-bottom: 1px solid var(--home-border-color);
        .name {
            line-height: 29px;
            font-weight: bold;
            font-size: 22px;
            color: var(--home-main-color);
            padding-bottom: 10px;
        }
        .under-line {
            position: absolute;
            bottom: -1px;
            width: 88px;
            height: 4px;
            background-color: var(--home-main-color);
            display: block;
        }
    }
}
</style>